<wsd-extended-card
  [loading]="!(projectCount$ | async)"
  [title]="'DATA_PORTAL.PROJECTS.TITLE' | translate">
  <div class="p-grid text-center" *ngIf="projectCount$ | async as data">
    <div class="p-col-6">
      <div class="counter">
        <a [href]="gsWebLink" target="_blank">
          {{ data.serviceRequestCount }}
          <i class="counter-icon fa fa-external-link-square-alt"></i>
        </a>
      </div>
      <label>
        {{'DATA_PORTAL.PROJECTS.SERVICE_REQUESTS' | translate}}
      </label>
    </div>

    <div class="p-col-6">
      <div class="counter">
        <a [href]="(liveData$ | async)?.link" target="_blank">
          {{ (liveData$ | async)?.count }}
          <i class="counter-icon fa fa-external-link-square-alt"></i>
        </a>
      </div>
      <label>
        {{'DATA_PORTAL.PROJECTS.DONATION_PROJECTS' | translate}}
      </label>
    </div>

  </div>
</wsd-extended-card>
